module.exports = __webpack_public_path__ + "media/images/emblems/Langrickenbach-b3204802c5760ba7144ee6bd0b18d982.GIF";